import {Color, Vector2} from 'three'

export const bgColor = new Color(0x000000)

export const canvasSize = new Vector2(800, 600)
export const windowSize = new Vector2(800, 600)
export const canvasResSize = new Vector2(800, 600)
